import clsx from 'clsx';
import React from 'react';

interface IHistoryFeesAmountProps {
	name: string;
	amount: number;
}
export const HistoryFeesAmount = (props: IHistoryFeesAmountProps): JSX.Element => {
	const { name, amount } =props;
	 return (
		 <div className="d-flex align-items-center">
			 {
				 name !== 'Percentage' && (
					 <div>
						 $
					 </div>
				 )
			 }
			 <div className={clsx('w-35px', name === 'Percentage' && 'ms-2')}>
				 {amount}
			 </div>
			 <div>
				 {name !== 'Percentage' ? 'USD' : '%'}
			 </div>
		 </div>
	 );
};
